/* Enhance Instafeed's native popup without copying or inventing social data. */
(() => {
  if (!document.getElementById('fm86-instagram')) return;
  let pending = false;
  function enhance() {
    pending = false;
    document.querySelectorAll('.instafeed-lightbox').forEach(popup => {
      popup.querySelectorAll('.post-date a').forEach(link => {
        const url = new URL(link.href, location.href);
        if (!/(^|\.)instagram\.com$/.test(url.hostname) || !/^\/(p|reel|tv)\//.test(url.pathname)) return;
        if (link.classList.contains('nu-instagram-post-link')) return;
        link.classList.add('nu-instagram-post-link');
        link.textContent = 'Zobacz post i komentarze ↗';
        link.setAttribute('aria-label', 'Zobacz post i komentarze na Instagramie — otwiera nową kartę');
      });
      const labels = { 'close popup': 'Zamknij post', 'previous post': 'Poprzedni post', 'next post': 'Następny post' };
      popup.querySelectorAll('[aria-label]').forEach(control => {
        const label = labels[control.getAttribute('aria-label')];
        if (label) control.setAttribute('aria-label', label);
      });
    });
  }
  new MutationObserver(records => {
    if (pending || !records.some(record => record.addedNodes.length)) return;
    pending = true;
    requestAnimationFrame(enhance);
  }).observe(document.body, { childList: true, subtree: true });
  enhance();
})();
